import { MenuItem, SxProps, Theme } from '@mui/material';

import { useLanguage } from '../../../hooks';
import { Globe2Outline } from '../../../icons';
import { useUserDataStore } from '../../../newStore/userDataStore';
import { LangParam } from '../../../types';
import { SingleSelect } from '../ComponentLibrary/SingleSelect';

const customStyles: SxProps<Theme> = {
  '&.MuiPaper-root': {
    borderRadius: '12px',
  },
};
export function LangSelector() {
  const lang = useLanguage();

  const userLangParam = useUserDataStore((state) => state.lang);
  const setLangParam = useUserDataStore((state) => state.actions.setLang);

  return (
    <SingleSelect
      value={userLangParam}
      startAdornment={
        <Globe2Outline
          fontSize='inherit'
          color='inherit'
        />
      }
      onChange={(e) => setLangParam(e.target.value as LangParam)}
      sx={customStyles}
    >
      <MenuItem value='es'>{lang.mainTopBar.languageOptions.es}</MenuItem>
      <MenuItem value='en'>{lang.mainTopBar.languageOptions.en}</MenuItem>
      <MenuItem value='pt'>{lang.mainTopBar.languageOptions.pt}</MenuItem>
    </SingleSelect>
  );
}
